// Copyright © 2021 Move Closer
import { toRefs, computed } from '@vue/composition-api';
import { abstractLinkProps } from '../../_abstract';
import { getSizePropDefinition, useSizeClass, useThemeClass } from '../../_composables';
import { bootstrapLinkColorRegistry, bootstrapLinkSizeRegistry, bootstrapLinkWeightRegistry } from './Link.config';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const bootstrapLinkProps = {
    ...abstractLinkProps,
    size: getSizePropDefinition(),
    color: {
        type: String,
        required: false
    },
    underline: {
        type: Boolean,
        required: false
    },
    bold: {
        type: Boolean,
        required: false
    }
};
/**
 * @author Łukasz Bęben <lukasz.beben@movecloser.pl>
 */
export function useBootstrapLink(props) {
    const { color, size, underline, bold } = toRefs(props);
    const sizeClass = computed(() => {
        return size.value ? useSizeClass(size, bootstrapLinkSizeRegistry).value : '';
    });
    const colorClass = computed(() => {
        if (!color || !color.value)
            return '';
        const colorRef = computed(() => color.value);
        return useThemeClass(colorRef, bootstrapLinkColorRegistry).value;
    });
    // todo: czy potrzebne?
    const decorationClass = computed(() => {
        return '';
        //   if (!underline || underline.value === undefined) return ''
        //   return bootstrapLinkDecorationRegistry[underline.value ? 'true' : 'false']
    });
    const weightClass = computed(() => {
        if (!bold || bold.value === undefined)
            return '';
        return bootstrapLinkWeightRegistry[bold.value ? 'true' : 'false'];
    });
    return { colorClass, sizeClass, decorationClass, weightClass };
}
